import React from 'react'
import ProjectSummary from './ProjectSummary';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import Spinner from '../spinner'

const ProjectList = ({
  projects,
  isFetchingProjects,
  isVerifying
}) => {
  if (isFetchingProjects || isVerifying) {
    return (
      <div style={{ position: 'absolute', top: '50%', width: '62%', textAlign: 'center' }}>
        <Spinner
          color="white"
          width="86px"
          height="86px"
        />
      </div>
    )
  }
  return (
    <div className="project-list section">
      { projects.length < 1 
               ? <h4 style={{color: 'white',position:'absolute', top: '35%', width: '62%', textAlign: 'center'}}> There are no projects ☹&nbsp;.
                 You can add some in the Create Projects Section! </h4> 
               : projects.map(project => {
                  return (
                    <Link to={'/project/' + project.id} key={project.id}>
                      <ProjectSummary projects={project} />
                    </Link>
        )
      })}
    </div>
  )
}


const mapStateToProps = state => {
  return {
    isVerifying:state.auth.isVerifying,
  }
}
export default connect(mapStateToProps)(ProjectList);
